<template>
  <div class="hf sensitive" data-demo-blur>
    <div v-if="hidden" class="hf-muted">HTML output is hidden in Demo Mode</div>
    <iframe v-else ref="frame" class="hf-frame" sandbox="allow-scripts" :srcdoc="doc" :style="{ height: `${height}px` }" title="Cell output" />
  </div>
</template>

<script>
import { sensitiveEgressBlocked } from '@/utils/demoEgress';

let frameSeq = 0;

export default {
  name: 'HtmlFrame',
  props: {
    html: { type: String, default: '' },
  },
  data() {
    frameSeq += 1;
    return { height: 120, token: `hf-${frameSeq}-${Math.random().toString(36).slice(2, 8)}` };
  },
  computed: {
    hidden() {
      return sensitiveEgressBlocked();
    },
    doc() {
      const probe = `<script>(function(){var t=${JSON.stringify(this.token)};function send(){parent.postMessage({kairon:'height',token:t,height:document.documentElement.scrollHeight},'*')}new ResizeObserver(send).observe(document.documentElement);window.addEventListener('load',send);setTimeout(send,50)})()<\/script>`;
      const d3 = '<script src="https://cdn.jsdelivr.net/npm/d3@7"><\/script>';
      const base = '<style>html,body{margin:0;padding:8px 12px;font:13px/1.5 "IBM Plex Sans",system-ui,sans-serif;color:#1a1918;background:#fff}</style>';
      return `<!doctype html><html><head><meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src https://cdn.jsdelivr.net 'unsafe-inline'; style-src 'unsafe-inline'; img-src data: blob:; font-src data:; connect-src 'none'; form-action 'none'; base-uri 'none'"><meta charset="utf-8">${base}${d3}${probe}</head><body>${this.html || ''}</body></html>`;
    },
  },
  mounted() {
    this.onMessage = (event) => {
      const m = event.data || {};
      if (m.kairon === 'height' && m.token === this.token && typeof m.height === 'number') {
        this.height = Math.min(Math.max(Math.ceil(m.height) + 2, 48), 2400);
      }
    };
    window.addEventListener('message', this.onMessage);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.onMessage);
  },
};
</script>

<style scoped>
.hf { background: #fff; }
.hf-frame { display: block; width: 100%; border: 0; }
.hf-muted { font-size: 11px; color: #8b877f; padding: 8px 12px; }
</style>
